<div class="flex flex-column" style="text-align: center;">
    <div *ngIf="footerMessage">
        {{footerMessage}}
    </div>
    <hr>
    <div>
        <em>{{ooVenue.name}}</em>
    </div>
    <div>
        <em>{{ooVenue.phone}}</em>
    </div>
    <div>
        <em>{{ooVenue.address1}} {{ooVenue.city}}, {{ooVenue.state}} {{ooVenue.zip}}</em>
    </div>
</div>